import {useInjection} from "inversify-react";
import {useCallback, useEffect, useState} from "react";
import ApiService from "../../services/apiService";
import {
    OrderDetailsDto,
    OrderPaymentStatus,
    OrderRefundApi,
    OrderRefundDto,
    OrderStage
} from "../../api";
import OrderRefundsList from "./orderRefundList";
import styles from "./orderRefundListContainer.module.less";
import {generatePath, useNavigate} from "react-router-dom";
import {RoutingPaths} from "../routing/routingContainer";

interface OrderRefundListContainerProps {
    orderDetails: OrderDetailsDto;
}

export default function OrderRefundsListContainer(props: OrderRefundListContainerProps) {
    const apiService = useInjection(ApiService);
    const [orderRefunds, setOrderRefunds] = useState<OrderRefundDto[] | null>();
    const navigate = useNavigate();

    const refreshOrderRefundsList = useCallback(async () => {
        try {
            const orderRefunds = await apiService.getApi(OrderRefundApi)
                .apiOrderRefundRefundsForOrderGet(props.orderDetails.orderGuid);
            setOrderRefunds(orderRefunds.data);
        } catch (e: any) {
            console.log(e.response.data);
        }
    }, [apiService, props.orderDetails.orderGuid]);

    const onAddClicked = () => {
        navigate(generatePath(RoutingPaths.orderRefundAdd.route, {
            guid: props.orderDetails.orderGuid
        }));
    }

    const canCreateRefund = () => {
        if (props.orderDetails!.orderPaymentStatus !== OrderPaymentStatus.Completed) return false;
        if (props.orderDetails!.orderValue === props.orderDetails!.refundsSum) return false;

        switch (props.orderDetails!.orderStage!) {
            case OrderStage.WaitingForPayment:
            case OrderStage.New:
            case OrderStage.Abandoned:
                return false;
            default:
                return true;
        }
    }

    const getAddRefundButtonMessage = () => {
        if (props.orderDetails!.paymentMethod?.value === "ShopPayment")
            return "Płatność dokonana w sklepie";

        if (props.orderDetails!.orderStage === OrderStage.Abandoned)
            return "Zamówienie zostało porzucone";

        if (props.orderDetails!.orderPaymentStatus !== OrderPaymentStatus.Completed
            || props.orderDetails!.orderStage === OrderStage.New
            || props.orderDetails!.orderStage === OrderStage.WaitingForPayment)
            return "Zamówienie nie zostało opłacone";

        if (props.orderDetails!.orderValue === props.orderDetails!.refundsSum)
            return "Zwrócono 100% kwoty";

        return "";
    }

    useEffect(() => {
        refreshOrderRefundsList();
    }, [refreshOrderRefundsList]);

    return <div className={styles.content}>
        {orderRefunds && props.orderDetails && <OrderRefundsList
            orderRefundsSum={props.orderDetails.refundsSum ?? 0}
            submitDisabled={!canCreateRefund()}
            data={orderRefunds || null}
            onAddClicked={onAddClicked}
        />}
        {props.orderDetails && orderRefunds && <strong style={{marginTop: "10px"}}>
            {getAddRefundButtonMessage()}
        </strong>}
    </div>
}
